import { useEffect,useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, Button, Card, CardContent, Grid, IconButton, Menu, MenuItem } from '@mui/material'
import { toast } from 'react-toastify'
import { post } from '../../../utils/axios'
import MoreVertIcon from '@mui/icons-material/MoreVert'

import './Children.css'

const Children = () => {

    const navigate = useNavigate()

    const [optionsMenu,setOptionsMenu] = useState(false)
    const [isLoading,setIsLoading] = useState(true)
    const [children,setChildren] = useState([])
    const [currentChild,setCurrentChild] = useState({})
    const open = Boolean(optionsMenu)

    const getData = () => {
        post('ChildUser/GetChildUserByParentId').then(({data}) => {
            if(data.isSuccess)
                setChildren(data.data)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        getData()
    },[])

    const goToEditPage = id => {
        navigate(`/app/children/${id}/segments`)
    }

    const goToTransactionsPage = id => {
        navigate(`/app/reports/child-transactions/${id}`)
    }

    const changeStatus = (e,status,id) => {
        const postedData = {
            id,
            status: !status,
            isDeleted: false
        }
        const child = children.find(child => child.id == id)
        if(!child)
            return toast.error('شریک مورد نظر یافت نشد')
        const childName = `${child.firstName} ${child.lastName}`
        post('ChildUser/ChangeStatusChildUserById',postedData).then(({data}) => {
            if(data.isSuccess){
                toast.success(`${childName} با موفقیت ${status ? 'غیرفعال' : 'فعال'} شد`)
                getData()
            }else
                toast.error('عملیات مورد نظر ناموفق بود')
        }).finally(() => setOptionsMenu(null))
    }

    const openOptions = (e,child) => {
        setOptionsMenu(e)
        setCurrentChild(child)
    }

    const deleteChild = () => {
        if(!currentChild)
            return toast.error('شریک مورد نظر یافت نشد')
        const postedData = {
            id: currentChild.id,
            status: false,
            isDeleted: true
        }
        const childName = `${currentChild.firstName} ${currentChild.lastName}`
        post('ChildUser/ChangeStatusChildUserById',postedData).then(({data}) => {
            if(data.isSuccess){
                toast.success(`${childName} با موفقیت حذف شد`)
                getData()
            }else
                toast.error('عملیات مورد نظر ناموفق بود')
        }).finally(() => setOptionsMenu(null))
    }

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">شریک های من</h3>
            <Button className="btn-plus-item" variant="contained" onClick={() => navigate('/app/children/add')} disabled={children.length > 1}><i className="fal fa-plus"></i></Button>
            <div className="safe-area">
                <Alert variant="standard" color="info" sx={{mb: 2}}>حداکثر 2 شریک می توانید اضافه کنید. در صورت تمایل برای افزودن شریک جدید باید یکی از شرکای قبلی را حذف کنید</Alert>
                {isLoading ? [...Array(4)].map((item,index) => <Card sx={{width: '100%',mb: 2}} key={index}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <div className="child-row child-row-placeholder">
                            <h4 className="animate"></h4>
                            <button className="active-deactive-children animate"></button>
                        </div>
                    </CardContent>
                </Card>) : (children.length ? children.map(child => <Card sx={{width: '100%',mb: 2}} key={child.id}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <div className="child-row">
                            <h4>{`${child.firstName} ${child.lastName}`}</h4>
                            {!child.isActive ? <span className="child-inactive-badge">غیرفعال</span> : ''}
                            <div className="child-row-btn-parent">
                                <IconButton onClick={e => openOptions(e.currentTarget,child)}><MoreVertIcon /></IconButton>
                            </div>
                        </div>
                    </CardContent>
                    <Menu anchorEl={optionsMenu} open={open} onClose={() => setOptionsMenu(null)}>
                        <MenuItem disabled={!currentChild.isActive} onClick={() => goToEditPage(currentChild.id)}>تخصیص منابع مالی</MenuItem>
                        <MenuItem disabled={!currentChild.isActive} onClick={() => goToTransactionsPage(currentChild.personId)}>گزارشات</MenuItem>
                        {/* <MenuItem disabled={!currentChild.isActive} onClick={() => navigate(`/app/children/edit/${currentChild.id}`)}>ویرایش</MenuItem> */}
                        <MenuItem onClick={e => changeStatus(e,currentChild.isActive,currentChild.id)}>{currentChild.isActive ? 'غیرفعال سازی' : 'فعال سازی'}</MenuItem>
                        <MenuItem onClick={() => deleteChild()}>حذف</MenuItem>
                    </Menu>
                </Card>) : <Alert severity="info">شریکی در سیستم ثبت نشده است. با استفاده از دکمه + پایین صفحه می توانید  شرکای جدیدی را در سیستم ثبت کنید</Alert>)}
            </div>
        </Grid>
    )
}

export default Children